/**
 * Whether a UGC amount sits below what the creator says she starts at: her
 * price per video times the videos asked for. Photos are left out, because her
 * starting price is stated per video. A reference shown to the brand, never a
 * rule: nothing is blocked on it.
 */
export const isBelowUgcStartingPrice = (
  amountCents: number | null | undefined,
  videoUnits: number,
  startingPriceCents: number | null | undefined
): boolean => {
  if (typeof amountCents !== 'number' || typeof startingPriceCents !== 'number') return false;
  if (videoUnits <= 0 || startingPriceCents <= 0) return false;
  return amountCents < startingPriceCents * videoUnits;
};
